import { ref, unref, watch, onMounted, nextTick, reactive } from "vue";
import {StorageUtils,getBase64} from 'xmgoing-utils';
import {delFileByBusId, delFileById, getFileList} from "../api/file";
import {message, UploadChangeParam} from "ant-design-vue";
import {QueryCommand} from "xmgoing-server";
import {getParamsStr} from "@/views/dataEmployeesDes/utils/ConditionNodeUtils";
import {useBaseCommFile} from "@/components/fileCtl/hooks/useBaseCommFile";

export function useComFileUpload({loadFileFlag,userUploadAction=null,props,selValue,ctx,businessId,fileId,params={},importParams=[]}:any,afterLoadFileList:any) {
  const fileList: any = ref([]);
  const uploadingFiles: any = ref([]);  // 正在上传的文件列表（带进度）

  const {headers}=useBaseCommFile();

  const loadFileByFileId=function (){
    const queryCommand = new QueryCommand({
      url:`/api/pe-attachment/attachment/detail`,
      method:'GET'
    });
    queryCommand.executeQueryPromise({params:{fileId}}).then((res:any)=>{
      res.name=res.fileName;
      fileList.value=[res];
    });
  }
  /**
   * 加载附件列表集合 HHHH
   * @param businessId
   * @param businessType
   * @param keepExisting 是否保留现有列表（当后端暂无数据时）
   */
  const loadFileList = async function (businessId: string,businessType: string, keepExisting = false) {
    if (businessId == null || businessId === "") {
      return;
    }
    const res = await getFileList(businessId,businessType);
    if(res&&Array.isArray(res.records)&&res.records.length>0){
      res.records.forEach((itemDb)=>{
        itemDb.name=itemDb.fileName;
      })
      fileList.value=res.records;
      afterLoadFileList&&afterLoadFileList(res.records);
    }else{
      // 如果设置了保留现有列表，则不清空（用于上传后立即查询可能还没同步的情况）
      if(!keepExisting){
        fileList.value=[];
      }
      if(unref(fileId)){
        nextTick(()=>{
          loadFileByFileId();
        })
      }
    }
  };

  /**
   * 加载附件信息
   */
  onMounted(() => {
    if (unref(props).businessId != null || unref(props).businessId !== "") {
      loadFileList(unref(props).businessId,unref(props).filetype);
    }
  });


  /**
   * 加载前操作
   */
  const beforeUpload=async function (file: File, UploadfileList: File[]){
    console.log('=== beforeUpload 触发 ===');
    console.log('单个文件:', file);
    console.log('文件列表:', UploadfileList);
    console.log('当前 businessId:', unref(props).businessId);
    console.log('当前 filetype:', unref(props).filetype);

    dataUpload["businessId"] = unref(props).businessId;
    dataUpload["businessType"] = unref(props).filetype;

    console.log('dataUpload 对象:', dataUpload);

    if((unref(props).accept.length>0)){
        const allowedTypes = unref(props).accept;

        const invalidFiles = UploadfileList.filter(f =>
          !allowedTypes.includes(f.type)
        );

        if (invalidFiles.length > 0) {
          const invalidNames = invalidFiles.map(f => f.name).join(', ');
          console.error('文件类型不符合要求:', invalidNames);
          message.error(`以下文件类型不符合要求: ${invalidNames}`);

          return false;
        }
     }

    //如果不是系统上传api则就无法删除操作 则直接设置为空
    if((unref(userUploadAction)+'').indexOf("/attachment/upload")<0){
      console.log('非系统上传API，跳过删除操作');
      return true;
    }
    //如果不是多上传
    if(unref(props).multiple===false){
      console.log('单文件上传，先删除旧文件');
      await delFileByBusId(unref(props).businessId).then(() => {});
      fileList.value=[];
    }

    console.log('beforeUpload 检查通过，允许上传');
    console.log('========================');
    return true;
  }

  const loading = ref<boolean>(false);
  const dataUpload:any = reactive({...unref(params)});

  /**
   * 上传成功后执行
   * @param info
   */
  const handleChange = async (info: UploadChangeParam) => {
    console.log('=== handleChange 触发 ===');
    console.log('文件状态:', info.file.status);
    console.log('文件信息:', info.file);

    if (info.file.status === 'uploading') {
      console.log('正在上传...');
      loading.value = true;

      // 更新或添加上传进度
      const existingIndex = uploadingFiles.value.findIndex(f => f.uid === info.file.uid);
      const progressInfo = {
        uid: info.file.uid,
        name: info.file.name,
        percent: Math.round(info.file.percent || 0)
      };

      if (existingIndex > -1) {
        uploadingFiles.value[existingIndex] = progressInfo;
      } else {
        uploadingFiles.value.push(progressInfo);
      }

      return;
    }
    if (info.file.status === 'done') {
      console.log('上传成功！');
      console.log('响应数据:', info.file.response);

      // 更新为100%
      const existingIndex = uploadingFiles.value.findIndex(f => f.uid === info.file.uid);
      if (existingIndex > -1) {
        uploadingFiles.value[existingIndex].percent = 100;
      }

      // 2秒后移除进度条
      setTimeout(() => {
        uploadingFiles.value = uploadingFiles.value.filter(f => f.uid !== info.file.uid);
      }, 2000);

      if(props.base64){
        getBase64(
          `/api/pe-attachment/attachment/showImg/` + info.file.response.data[0].id
        ).then((res) => {
          ctx.emit("update:value", res);
        });
      }else{
        if(props.multiple===false){
          ctx.emit('update:value', '/api/pe-attachment/attachment/showImg/'+info.file.response.data[0].id);
          if(info.file&&info.file.response){
            fileList.value=[info.file.response.data[0]];
          }
        }
      }
      unref(props).businessId?ctx.emit('update:busId',unref(props).businessId):'';
      //如果是自己定义了 上传路径 则返回后台请求内容给前台
      if(unref(userUploadAction)){
        ctx.emit('update:value',info.file.response.data);
      }
      //如果设置了true 则直接返回路径 用于展示
      if(unref(selValue)){
        ctx.emit('update:value',`/api/pe-attachment/attachment/showImg/` + info.file.response.data[0].id);
      }
      // 在文件列表更新后立即发送done事件
      ctx.emit('done', {fileList:unref(fileList)});
      loading.value = false;

      // 延迟1秒后再加载完整的文件列表（给后端时间同步数据），并保留现有列表
      setTimeout(() => {
        unref(props).businessId?loadFileList(unref(props).businessId,unref(props).filetype, true):'';
      }, 1000);

      console.log('上传处理完成');
      console.log('========================');
    }
    if (info.file.status === 'error') {
      console.error('上传失败！');
      console.error('错误信息:', info.file.error);

      // 移除失败的文件进度
      uploadingFiles.value = uploadingFiles.value.filter(f => f.uid !== info.file.uid);

      loading.value = false;
      message.error('upload error');
      console.log('========================');
    }
  }

  // 初始化dataUpload
  dataUpload["businessId"] = unref(props).businessId;
  dataUpload["businessType"] = unref(props).filetype;

  if(unref(importParams)){
    unref(importParams).forEach((propItem)=>{
      const {paraName,valueType,filterValue,filterSubValue}=propItem;
      dataUpload[paraName]  = `${getParamsStr({varSubParam:filterSubValue,paramValType: valueType, paramVal: filterValue})}`
    })
  }

  watch(importParams,()=>{
    unref(importParams).forEach((propItem)=>{
      const {paraName,valueType,filterValue,filterSubValue}=propItem;
      dataUpload[paraName]  = `${getParamsStr({varSubParam:filterSubValue,paramValType: valueType, paramVal: filterValue})}`
    })
  })

  // 防止重复加载的定时器
  let businessIdChangeTimer: any = null;
  watch(businessId,(_newVal)=>{
    // 清除之前的定时器，防止频繁触发
    if(businessIdChangeTimer){
      clearTimeout(businessIdChangeTimer);
    }
    // 延迟500ms后再加载，避免与上传成功后的加载冲突
    businessIdChangeTimer = setTimeout(() => {
      loadFileList(unref(props).businessId, unref(props).filetype, true);
    }, 500);

    if(Array.isArray(unref(props).businessId)){
      dataUpload["businessId"]=unref(props).businessId.join("");
    }
  })

  /**
   * 刷新附件列表信息
   */
  const flushFileList=function (){
    loadFileList(unref(props).businessId,unref(props).filetype);
  }

  /**
   * 删除附件操作
   * @param file
   */
  const removeFile =async function (file) {
    //删除记录根据附件id
    if (file.id) {
      await delFileById(file.id);
      loadFileList(unref(props).businessId,unref(props).filetype);
    }
    //删除记录
    if(file.response&&file.response.data){
      await delFileById(file.response.data[0].id);
      loadFileList(unref(props).businessId,unref(props).filetype);
    }
  };

  const clearFileList=function (){
    fileList.value=[];
  }

  return {
    getFileList:loadFileList,
    clearFileList,
    removeFile,
    flushFileList,
    dataUpload,
    loading,
    handleChange,
    beforeUpload,
    fileList,
    uploadAction:(userUploadAction&&(userUploadAction+'').length>0)?userUploadAction:ref("/api/pe-attachment/attachment/upload"),
    headers,
    loadFileList,
    uploadingFiles  // 返回正在上传的文件列表
  };
}
